import { CreditCard, X } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export function SaleBanner() {
  const [isVisible, setIsVisible] = useState(true)
  const navigate = useNavigate()

  if (!isVisible) return null

  const handleBannerClick = () => {
    navigate('/billing')
  }

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsVisible(false)
  }

  return (
    <div 
      onClick={handleBannerClick}
      className="relative bg-gradient-to-r from-violet-500/10 via-fuchsia-500/15 to-violet-500/10 border-b border-violet-400/15 text-center py-3 px-4 text-sm cursor-pointer hover:from-violet-500/15 hover:via-fuchsia-500/20 hover:to-violet-500/15 transition-all"
    >
      <span className="inline-flex items-center gap-1.5 text-violet-100/90">
        <CreditCard className="size-4 text-violet-200" />
        <span className="font-semibold text-white">Credit Card payments now available</span>
        <span className="hidden sm:inline"> on PixelMaker!</span>
      </span>
      <button
        onClick={handleDismiss}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-violet-200/60 hover:text-white hover:bg-violet-400/10 transition-all"
        aria-label="Dismiss banner"
      >
        <X className="size-4" />
      </button>
    </div>
  )
}
